var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"no-transform",attrs:{"disabled":_vm.details?.confirm_status != '1',"outlined":"","width":_vm.width,"elevation":"0","color":"primary"},on:{"click":_vm.build}},[_vm._v("Print Receipt")])
}
var staticRenderFns = []

export { render, staticRenderFns }